import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=20c2049e&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=20c2049e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2049e",
  null
  
)

export default component.exports